import rg4js from 'raygun4js';
import {
  environmentVariables,
  isProduction,
} from './utils/environmentVariables';

const { RAYGUN_KEY } = environmentVariables;

export default {
  init: () => {
    if (RAYGUN_KEY) {
      rg4js('enableCrashReporting', true);
      rg4js('apiKey', RAYGUN_KEY);
    }
  },
  logError: (error: any) => {
    if (RAYGUN_KEY && isProduction()) {
      rg4js('send', error);
    }
  },
};
